import { Suspense, useEffect, useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
// import { SubTitle } from "../../Components/CustomComponents/index.js";

// import styles from "./styles/user_management.module.scss";
// import { ToastContainer, toast } from "react-toastify";
//
import { useDispatch } from "react-redux"; // for getting and setting data into local redux
// import CustomerBlockModal from "../../Components/Modals/CustomerBlockModal";
import { Col, Form, Row, Spinner } from "react-bootstrap";
import ToolTip from "../../Components/ToolTip.js";
// import ChangePasswordModal from "../../Components/Modals/ChangePasswordModal.js";
import { PiHandCoinsFill } from "react-icons/pi";
import Table from "../../Components/Table/Table.js";
import LogoutModal from "../../Components/modal/LogoutModal.jsx";
import SendCoinModal from "../../Components/modal/SendCoinModal.jsx";
import { useBlockUnblockUserMutation, useGetAllUsersQuery } from "../../store/apis/userApi.js";
import ThemeSpinner from "../../Components/general/ThemeSpinner.jsx";
import ThemeInput from "../../Components/input/ThemeInput.jsx";
import { Controller, useForm } from "react-hook-form";
import { PlaceholderButton } from "../../Components/Placeholders.jsx";
import SwitchWithLoader from "../../Components/SwitchWithLoader/SwitchWithLoader.js";
import { errorMsg, successMsg } from "../../constants/msgs.js";
import { result } from "lodash";

const UserManagementScreen = ({ setPage }) => {
  const dispatch = useDispatch();
  const {
    register,
    reset,
    control,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({ mode: "onChange" });

  // const [data, setData] = useState([]);
  const [indicationMessage, setIndicationMessage] = useState("loading...");
  const [editedData, setEditedData] = useState("");

  const [apiData, setApiData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);

  const [loading, setLoading] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [sendCoinModal, setSendCoinModal] = useState(false);
  const [coinsModal, setCoinsModal] = useState(false);
  const [forView, setForView] = useState(true);
  const [editModal, setEditModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);

  const [currentPage, setCurrentPage] = useState(1); // todo
  const [pageSize, setPageSize] = useState(10); // todo
  const [totalRecords, setTotalRecords] = useState(0); // todo
  const [totalPages, setTotalPages] = useState(0); // todo
  const [dataFetched, setDataFetched] = useState(false); // todo

  const [searchQuery, setSearchQuery] = useState("");

  const { data, isSuccess, isLoading, isFetching, refetch } =
    useGetAllUsersQuery({ refetchOnMountOrArgChange: true });

  const handleSearchChange = (event) => {
    const query = event.target.value;
    setSearchQuery(query);
    setDataFetched(false);
  };

  useEffect(() => {
    if (isSuccess && data?.data) {
      console.log(data);
      // setPageSize(data.links.per_page);
      // setCurrentPage(data.links.current);
      // setTotalRecords(data.links.total_records);
      // setTotalPages(data.links.total);
      // setRowData(data.data);
      // setDataFetched(true);

      setApiData(data.data); // Save raw API data
      setFilteredData(data.data); // Initially same as raw

      if (data.data.length === 0) {
        setIndicationMessage("Data not available");
      }
    }
  }, [data, isSuccess]);

  useEffect(() => {
    if (searchQuery.length >= 3) {
      const lowerQuery = searchQuery.toLowerCase();
      const results = apiData.filter((user) =>
        user.full_name.toLowerCase().includes(lowerQuery)
      );
      console.log(results);
      if (results.length === 0) {
        setIndicationMessage("Data not found.")
      }
      setFilteredData(results);
    } else {
      setFilteredData(apiData); // Reset to all if searchQuery < 3
    }
  }, [searchQuery, apiData]);

  const handleBlockModalOpen = () => {
    setViewModal(true);
  };

  // const handleBlockModalClose = () => {
  //   setViewModal(false);
  //   setEditedData("");
  // };

  // const handleSendCoinModalOpen = () => {
  //   setSendCoinModal(true);
  // };

  // const handleSendCoinModalClose = () => {
  //   setSendCoinModal(false);
  //   setEditedData("");
  // };

  const handleCoinsModalOpen = () => {
    setCoinsModal(true);
  };

  const handleCoinsModalClose = () => {
    setCoinsModal(false);
    setEditedData("");
  };

  // const [blockUser, { isLoading: isBlocking }] = useBlockUserMutation();
  // const [unBlockUser, { isLoading: isUnBlocking }] = useUnBlockUserMutation();
  const [userBlockOrUnBlock, { isLoading: isSwitching }] =
    useBlockUnblockUserMutation();

  const handleBlockOrUnblock = async (userSlug, isBlock) => {
    console.log(userSlug);
    console.log(isBlock);

    try {
      const response = await userBlockOrUnBlock({ id: userSlug });
      console.log(response);

      if (response.data.statusCode === 200) {
        await refetch();
        setLoading(false);
        // handleBlockModalClose();
        successMsg(response?.data?.message);
      }
    } catch (error) {
      // console.log(error);
      errorMsg(error.message, "error");
    }
  };

  // const handleDeleteModalOpen = () => {
  //   setDeleteModal(true);
  // };

  const handleDeleteModalClose = () => {
    setDeleteModal(false);
    setEditedData("");
  };

  // const [deleteUser, { isLoading: isDeleting }] = useDeleteUserMutation();

  const deleteData = async (slug) => {
    // try {
    //   // const { data } = await deleteUser(slug);
    //   // console.log(data);
    //   if (data.code === 200) {
    //     // await refetch();
    //     handleDeleteModalClose();
    //     SuccessToast(data.message);
    //   }
    // } catch (error) {
    //   // console.log(error);
    //   Toast(error.message, "error");
    // }
  };

  function indication() {
    return indicationMessage;
    // return <ClipLoader color="#1C75BC" />;
  }

  const columns = [
    {
      dataField: "full_name",
      text: "Name",
      sort: true,
      headerStyle: {
        // width: "150px",
      },
    },
    {
      dataField: "email",
      text: "Email",
      // sort: true,
      headerStyle: {
        // width: "200px",
      },
    },
    {
      dataField: "country",
      text: "Country",
      // sort: true,
      headerAlign: "center",
      align: "center",
      headerStyle: {
        // width: "150px",
      },
    },
    {
      dataField: "coins",
      text: "Coins",
      headerAlign: "center",
      align: "center",
      headerStyle: {},
    },
    {
      dataField: "is_blocked",
      text: "Status",
      sort: true,
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "100px",
      },
      formatter: (cellContent, row) => {
        return (
          <SwitchWithLoader
            isChecked={!row.is_blocked}
            // isLoading={isBlocking || isUnBlocking}
            onChange={() => handleBlockOrUnblock(row.slug, row.is_blocked)}
          />
        );
      },
    },
    {
      dataField: "actions",
      text: "Actions",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "100px",
      },
      formatter: (cellContent, row) => {
        // console.log(row)
        if (row.slug) {
          return (
            <div className="d-flex justify-content-center align-items-center ">
              {/* <ToolTip placement={"top"} content={"View Details"}>
                <div
                  className="d-flex justify-content-center align-items-center bg-primary-hover rounded-3 p-2 mx-2 "
                  role="button"
                  onClick={() => {
                    setForView(true);
                    setEditedData(row);
                    handleBlockModalOpen();
                  }}
                >
                  <span className={`d-flex align-items-center pe-1`}>
                    <IoIosEye size={22} />
                  </span>
                  {/* <span className="d-none d-xl-block">View</span> */}
              {/* </div>
              </ToolTip> 
              */}

              <ToolTip placement={"top"} content={"Send Coins"}>
                <div
                  className="d-flex justify-content-center align-items-center bg-red-hover rounded-3 p-2 mx-2"
                  role="button"
                  onClick={() => {
                    setForView(true);
                    setEditedData(row);
                    handleCoinsModalOpen();
                  }}
                >
                  <span className={`d-flex align-items-center pe-1`}>
                    <PiHandCoinsFill size={22} />
                  </span>
                  {/* <span className="d-none d-xl-block">Change Pass</span> */}
                </div>
              </ToolTip>
            </div>
          );
        }
      },
    },
  ];

  return (
    <div className="MainContainer">
      <SendCoinModal
        isOpen={coinsModal}
        handleCoinsModalClose={handleCoinsModalClose}
        selectedData={editedData}
        refetch={refetch}
      />

      <div className="headerContainer">
        <Row className="w-100 align-items-center">
          <Col md={6}>
            {/* <div>
              <SubTitle text={"User Management"} classes="text-black" />
            </div> */}
          </Col>

          <Col md={6}>
            {
              isLoading ?
                <PlaceholderButton />
                :
                <Controller
                  name="search"
                  control={control}
                  render={({ field }) => (
                    <>
                      <Form.Control
                        {...field}
                        placeholder="Search by name"
                        type="text"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                      />
                    </>
                  )}
                />}
          </Col>
        </Row>
      </div>

      <div className="mainTable">
        {isLoading ? (
          <ThemeSpinner />
        ) : (
          <Table
            // classes={`${dataFetched && isFetching ? "blur-table" : ""}`}
            data={filteredData || []}
            columns={columns}
            indication={indication}
            // totalRecords={totalRecords} // todo
            // totalPages={totalPages} // todo
            // pageSize={pageSize} // todo
            // currentPage={currentPage} // todo
            // setCurrentPage={setCurrentPage} // todo
            // setPageSize={setPageSize} // todo
            // refetch={refetch} // todo
            refetch={() => { }}
          />
        )}
      </div>
    </div>
  );
};

export default UserManagementScreen;
